import { FailureSource } from '@sparelabs/error-types'
import { z } from '@sparelabs/zod'
import { ServiceFleetPriority } from './ServiceFleetTypes'

export const FleetRankingSuccessSchema = z.object({
  fleetIds: z.array(z.string()),
  success: z.literal(true),
  details: z.object({
    scheduledPickupTs: z.number().or(z.null()),
    scheduledDropoffTs: z.number().or(z.null()),
  }),
  priority: z.nativeEnum(ServiceFleetPriority),
})

export type IFleetRankingSuccessResult = z.infer<typeof FleetRankingSuccessSchema>

export const FleetRankingFailureSchema = z.object({
  fleetIds: z.array(z.string()),
  success: z.literal(false),
  error: z
    .object({
      failureMessage: z.string(),
      failureSource: z.nativeEnum(FailureSource),
    })
    .optional(),
  priority: z.nativeEnum(ServiceFleetPriority),
})

export type IFleetRankingFailureResult = z.infer<typeof FleetRankingFailureSchema>

export type IFleetRankingResult = IFleetRankingSuccessResult | IFleetRankingFailureResult
